export default __webpack_public_path__ + "static/media/mockup-dark.aa846b9e.png";